import { legacyPlugins } from "/home/runner/work/psj-nuxt/psj-nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}